import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'
import Transformer from '../../transformers/purchase/freight'

export default (payload) => {
  const url = 'purchase/freight/'
  const transformed = Transformer.send(payload)
  
  return errorHandler(Vue.$http.post(url, transformed
   )
  )
    .then(response => response.data)
}


// WEBPACK FOOTER //
// ./src/services/purchase/sendFreight.js